import { AuthenticationService } from '../../services/authentication.service';
import { UserService } from '../../services/user.service';
import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { BreadcrumbService } from 'src/app/services/breadcrumb.service';
import { TitleCasePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { resolveCountryLabel } from 'src/app/shared/profile-contact.util';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
})
export class ProfileComponent implements OnInit {
  user: any;
  nombres: string = '';
  apellidos: string;
  email: string;
  codigo: string;
  telefono: string;
  fechanac: Date;
  genero: string;
  pais: string;
  uid: string;
  avatar: string;
  uid_in_userdatabase: any;
  currentuid: string;
  urlid: string;

  noMyUser: boolean = false;
  usuario: any;

  es: boolean = false;
  en: boolean = false;
  ar: boolean = false;
  idioma: boolean = false;
  click: boolean = false;
  colegioUid: any;

  constructor(
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private breadService: BreadcrumbService,
    private translate: TranslateService
  ) {}

  private getDisplayCountry(value: any): string {
    const language = this.translate.currentLang || this.translate.getDefaultLang() || 'es';
    return resolveCountryLabel(value, language);
  }

  private parseDateValue(value: any): Date {
    if (!value) {
      return null;
    }

    if (value instanceof Date) {
      return value;
    }

    if (value.seconds !== undefined) {
      return new Date(value.seconds * 1000);
    }

    return new Date(value);
  }

  private applyProfileUser(user: any, uidInDatabase?: string): void {
    this.user = user;
    this.uid_in_userdatabase = uidInDatabase || this.uid_in_userdatabase;
    this.uid = this.urlid;
    this.nombres = user.name;
    this.apellidos = user.last_name;
    this.email = user.email;
    this.codigo = user.codigo || user.code;
    this.telefono = user.telefono || user.phone_number;
    this.fechanac = this.parseDateValue(user.fechanac || user.date_of_birth);
    this.genero = user.genero || user.gender;
    this.pais = this.getDisplayCountry(user.country || user.pais);
    this.avatar = user.avatar;
    this.usuario = user.usuario || user.username;
    this.colegioUid = (user.colegios || user.schools || [])[0];
  }

  ngOnInit() {
    if (localStorage.getItem('idioma')) {
      var lang = localStorage.getItem('idioma');

      switch (lang) {
        case 'es':
          this.es = true;
          break;
        case 'en':
          this.en = true;
          break;
        case 'ar':
          this.ar = true;
          break;
        default:
          break;
      }
    } else {
      this.es = true;
    }

    this.urlid = this.activatedRoute.snapshot.params['uid'];

    this.authenticationService.getStatus().subscribe(
      (status) => {
        this.currentuid = status.uid;
        if (this.urlid != status.uid) {
          this.noMyUser = true;
          this.userService.getUserById(status.uid).subscribe((data) => {
            if (data[0]) {
              this.user = data[0].payload.doc.data();
            }
          });
          this.userService.getUserById(this.urlid).subscribe((data) => {
            if (data[0]) {
              this.applyProfileUser(data[0].payload.doc.data(), data[0].payload.doc.id);
            }
          });
        } else {
          this.noMyUser = false;
          this.userService.getUserById(this.urlid).subscribe(
            (data) => {
              if (data[0]) {
                this.applyProfileUser(data[0].payload.doc.data(), data[0].payload.doc.id);
              }
            },
            (error) => {
              console.log(error);
            }
          );
        }
      },
      (error) => {
        console.log(error);
      }
    );

    this.userService.getUserinfo().subscribe((data: any) => {
      const user = data?.payload?.doc?.data ? data.payload.doc.data() : data;
      const uid = user?.uid || data?.payload?.doc?.id;

      if (!user || !uid) {
        return;
      }

      if (!this.noMyUser && this.urlid === uid) {
        this.applyProfileUser(user, data?.payload?.doc?.id);
      }
    });
  }
  UpdateBreadcrumb(name, url) {
    this.breadService.addtobread(name, url);
  }
  get chaturl() {
    return [this.uid, this.urlid].sort().join('|');
  }

  changeLang(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('idioma', lang);
  }

  espanol() {
    this.translate.use('es');
    this.es = true;
    this.en = false;
    this.ar = false;
    localStorage.setItem('idioma', 'es');
    this.activeLanguage();
  }

  ingles() {
    this.translate.use('en');
    this.en = true;
    this.es = false;
    this.ar = false;
    localStorage.setItem('idioma', 'en');
    this.activeLanguage();
  }

  arabe() {
    this.translate.use('ar');
    this.en = false;
    this.es = false;
    this.ar = true;
    localStorage.setItem('idioma', 'ar');
    this.activeLanguage();
  }

  changeColor() {
    this.click = !this.click;
  }

  activeLanguage() {
    this.idioma ? (this.idioma = false) : (this.idioma = true);
    console.log('hola', this.idioma);
  }
}
